import React, { useEffect, useState } from "react";
import { Waves } from "lucide-react";
import { api } from "../lib/api";

const money = (v) => (v >= 1e6 ? `$${(v / 1e6).toFixed(1)}M` : `$${Math.round(v / 1e3)}k`);
const DOT = { ok: "bg-emerald-400", err: "bg-rose-400" };

export const FlowCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get("/flow/unusual", { params: { limit: 15 } }).then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  const items = d?.items || [], dark = d?.dark_pool || [];
  return (
    <div className="bg-[#060b18] border border-[#00F0FF22] rounded-2xl p-4 space-y-3" data-testid="flow-card">
      <div className="flex items-center gap-2 flex-wrap">
        <Waves className="w-4 h-4 text-[#00F0FF]" />
        <p className="text-xs nx-mono tracking-widest text-cyan-300/70">Unusual Flow</p>
        <span className="text-[10px] text-cyan-200/40">{d?.ts ? new Date(d.ts).toLocaleString() : ""} · signal only, no orders</span>
        <div className="ml-auto flex items-center gap-3" data-testid="flow-sources">
          {Object.entries(d?.sources || {}).map(([k, v]) => (
            <span key={k} className="flex items-center gap-1 text-[10px] nx-mono text-cyan-200/60" title={v} data-testid={`flow-source-${k}`}>
              <span className={`w-2 h-2 rounded-full ${DOT[v] || "bg-white/20"}`} />{k}{v !== "ok" ? `: ${v}` : ""}
            </span>
          ))}
        </div>
      </div>
      {!items.length ? <p className="text-xs text-cyan-200/40" data-testid="flow-empty">No unusual contracts yet.</p> : (
        <table className="w-full text-[12px] nx-mono" data-testid="flow-table">
          <thead className="text-cyan-300/50 text-[10px] tracking-widest"><tr>{["TICKER", "C/P", "STRIKE", "EXP", "PREMIUM", "SCORE"].map((h) => <th key={h} className="text-left py-1 font-normal">{h}</th>)}</tr></thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.contract} className="border-t border-white/5" data-testid={`flow-row-${i.contract}`}>
                <td className="py-1 text-white font-bold">{i.ticker}</td>
                <td className={i.type === "call" ? "text-emerald-300" : "text-rose-300"}>{i.type === "call" ? "C" : "P"}</td>
                <td className="text-cyan-50/80">{i.strike}</td>
                <td className="text-cyan-50/60">{i.expiry.slice(5)}</td>
                <td className="text-cyan-50/80">{money(i.premium)}</td>
                <td><span className={`px-1.5 rounded ${i.score >= 85 ? "bg-amber-400/20 text-amber-200" : "text-cyan-100/70"}`}>{i.score}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div data-testid="flow-dark-pool">
        <p className="text-[10px] nx-mono tracking-widest text-cyan-300/50 mb-1">DARK POOL (DELAYED)</p>
        {!dark.length ? <p className="text-xs text-cyan-200/40">No dark-pool data{d?.sources?.finra === "not configured" ? " — FINRA not configured" : ""}.</p>
          : <p className="text-[12px] text-cyan-50/80 nx-mono">{dark.slice(0, 10).map((x) => `${x.ticker} ${(x.ats_shares / 1e6).toFixed(1)}M`).join(" · ")} <span className="text-cyan-200/40">· week {dark[0].week}</span></p>}
      </div>
    </div>
  );
};
